import { Grid2, FormGroup, Paper } from "@mui/material";
import DarkModeSetting from "./settings/DarkModeSetting";
import HeaderBar from "../Shared/HeaderBar/HeaderBar";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"
import ClearStorageSetting from "./settings/ClearStorageSetting";

//Page for application settings
export default function SettingsPage() {

    return (
        <>  
            <HeaderBar></HeaderBar>
            <Grid2 container={true} paddingTop={'1em'} justifyContent={'center'} alignItems={'center'} direction={'row'} wrap={"wrap"} id={"DashboardPageGrid"}>
                <FormGroup>
                    <Paper elevation={3} sx={{display:'flex', justifyContent:'center', marginBottom:'1em'}}><DarkModeSetting /></Paper>
                    <ClearStorageSetting />
                </FormGroup>
            </Grid2>
            <NavigationBar></NavigationBar>
        </>
    );
}
